import { render, staticRenderFns } from "./QuestionYesNo.vue?vue&type=template&id=9fc2d55a&"
import script from "./QuestionYesNo.vue?vue&type=script&lang=js&"
export * from "./QuestionYesNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports